/* Product page reservation card (<zl-product-waitlist>, snippets/zl-product-waitlist.liquid).

   Linked with the landing page card (fdd-unlock) through the same browser flags:
   - "fdd-unlock:<tag>" = "1"  -> this visitor reserved (either page);
   - "fdd:subscribed"   = "1"  -> this visitor subscribed (member banner uses it).

   Standard Shopify submit, so Shopify's bot protection always runs. Shopify sends
   the visitor back with ?zl_waitlist_subscribed=<block id>; that is the success
   signal. The count shown is the server's (starting number + Flow count); right
   after a submit, if Flow hasn't caught up yet, the page shows +1 for that view.

   Performance: nothing global. Each card listens to its own form, its own input
   and the theme's variant:changed event, and only while it is in the page. */
(function () {
  if (window.customElements && customElements.get('zl-product-waitlist')) return;

  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var SUB_KEY = 'fdd:subscribed';

  function store(kind) {
    try { return window[kind]; } catch (e) { return null; }
  }
  function get(kind, key) {
    var s = store(kind);
    try { return s ? s.getItem(key) : null; } catch (e) { return null; }
  }
  function set(kind, key, value) {
    var s = store(kind);
    try { if (s) s.setItem(key, value); } catch (e) {}
  }
  function drop(kind, key) {
    var s = store(kind);
    try { if (s) s.removeItem(key); } catch (e) {}
  }
  function number(node) {
    return node ? parseInt(node.textContent.replace(/[^0-9]/g, ''), 10) : NaN;
  }

  class ZlProductWaitlist extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.form = this.querySelector('form');
      this.email = this.querySelector('[data-zl-waitlist-email]');
      this.message = this.querySelector('[data-zl-waitlist-message]');
      this.done = this.querySelector('[data-zl-waitlist-done]');
      this.doneMain = this.querySelector('[data-zl-waitlist-done-main]');
      this.count = this.querySelector('[data-zl-waitlist-count]');
      this.more = this.querySelector('[data-zl-waitlist-more]');
      this.back = this.querySelector('[data-zl-waitlist-return]');
      this.blockId = this.dataset.blockId;
      this.reservedKey = 'fdd-unlock:' + (this.dataset.reservedTag || 'P3Lite_Reserved');
      this.beforeKey = this.reservedKey + ':before';

      this.onSubmit = this.onSubmit.bind(this);
      this.onInput = this.onInput.bind(this);
      this.onVariant = this.onVariant.bind(this);

      if (this.form) this.form.addEventListener('submit', this.onSubmit);
      if (this.email) this.email.addEventListener('input', this.onInput);
      this.price = this.querySelector('[data-zl-waitlist-price]');
      if ((this.dataset.showWhen && this.dataset.showWhen !== 'always') || this.price) {
        document.addEventListener('variant:changed', this.onVariant);
      }

      this.restore();
    }

    disconnectedCallback() {
      this._ready = false;
      document.removeEventListener('variant:changed', this.onVariant);
      if (this.form) this.form.removeEventListener('submit', this.onSubmit);
      if (this.email) this.email.removeEventListener('input', this.onInput);
    }

    /* idle | invalid (red line) | success / repeat (the three-line list; line 1
       is the success or the "already on the list" text). */
    show(state) {
      var reserved = state === 'success' || state === 'repeat';
      if (this.message) {
        this.message.setAttribute('data-state', state === 'invalid' ? 'error' : 'idle');
        this.message.textContent = state === 'invalid' ? this.message.dataset.msgInvalid || '' : '';
      }
      if (this.done) {
        this.done.hidden = !reserved;
        this.done.setAttribute('data-state', reserved ? state : 'idle');
        if (reserved && this.doneMain) {
          this.doneMain.textContent = this.done.dataset[state === 'repeat' ? 'msgRepeat' : 'msgSuccess'] || '';
        }
      }
      this.classList.toggle('is-invalid', state === 'invalid');
    }

    setCount(n) {
      if (!this.count || isNaN(n)) return;
      this.count.textContent = n.toLocaleString('en-US');
      if (this.more) this.more.textContent = Math.max(0, n - (parseInt(this.dataset.avatars, 10) || 0));
    }

    onSubmit(event) {
      var value = (this.email && this.email.value || '').trim();
      if (!EMAIL.test(value)) {
        event.preventDefault();
        this.show('invalid');
        if (this.email) this.email.focus();
        return;
      }
      this.show('idle');
      if (this.back) {
        var params = new URLSearchParams(location.search);
        params.set('zl_waitlist_subscribed', this.blockId);
        this.back.value = location.pathname + '?' + params.toString() + '#' + this.id;
      }
      var n = number(this.count);
      if (!isNaN(n)) set('sessionStorage', this.beforeKey, String(n));
    }

    /* Typing clears the red line or the list, so another email can be used. */
    onInput() {
      var invalid = this.classList.contains('is-invalid');
      var listed = this.done && !this.done.hidden;
      if (invalid || listed) this.show('idle');
    }

    onVariant(event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;
      var mode = this.dataset.showWhen || 'always';
      var show = mode === 'always' || (mode === 'sold_out' && !variant.available) || (mode === 'in_stock' && variant.available);
      this.classList.toggle('is-hidden', !show);
      if (this.price) this.updatePrice(variant);
    }

    /* Prices arrive in cents; format them with the shop's money format. */
    formatMoney(cents) {
      var format = this.price.dataset.moneyFormat || '${{amount}}';
      var value = (Number(cents) || 0) / 100;
      var parts = function (decimals, thousands, mark) {
        var fixed = value.toFixed(decimals).split('.');
        var whole = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return fixed[1] ? whole + mark + fixed[1] : whole;
      };
      return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
        switch (key) {
          case 'amount_no_decimals': return parts(0, ',', '.');
          case 'amount_with_comma_separator': return parts(2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return parts(0, '.', ',');
          case 'amount_with_apostrophe_separator': return parts(2, "'", '.');
          default: return parts(2, ',', '.');
        }
      });
    }

    updatePrice(variant) {
      var now = this.price.querySelector('[data-zl-waitlist-price-now]');
      var was = this.price.querySelector('[data-zl-waitlist-price-was]');
      if (now && variant.price != null) now.textContent = this.formatMoney(variant.price);
      if (was) {
        var on = variant.compare_at_price && variant.compare_at_price > variant.price;
        was.hidden = !on;
        if (on) was.textContent = this.formatMoney(variant.compare_at_price);
      }
    }

    restore() {
      var params = new URLSearchParams(location.search);
      var justPosted = params.get('zl_waitlist_subscribed') === this.blockId;
      var serverState = (this.message && this.message.getAttribute('data-state') === 'error') ? 'error'
        : (this.done && this.done.getAttribute('data-state')) || 'idle';

      if (justPosted) {
        /* Count: +1 for this view only if Flow hasn't counted it yet. */
        var before = parseInt(get('sessionStorage', this.beforeKey), 10);
        drop('sessionStorage', this.beforeKey);
        var now = number(this.count);
        if (!isNaN(before) && !isNaN(now) && now <= before) this.setCount(before + 1);

        set('localStorage', this.reservedKey, '1');
        set('localStorage', SUB_KEY, '1');
        try { document.dispatchEvent(new CustomEvent('fdd:subscribed')); } catch (e) {}
        this.show('success');

        params.delete('zl_waitlist_subscribed');
        params.delete('customer_posted');
        var rest = params.toString();
        history.replaceState(null, '', location.pathname + (rest ? '?' + rest : '') + location.hash);

        var self = this;
        var bring = function () {
          requestAnimationFrame(function () { self.scrollIntoView({ block: 'center' }); });
        };
        if (document.readyState === 'complete') bring();
        else window.addEventListener('load', bring, { once: true });
      } else if (serverState === 'error') {
        this.classList.add('is-invalid');
      } else if (serverState === 'repeat' || get('localStorage', this.reservedKey) === '1') {
        this.show('repeat');
      }
    }
  }

  if (window.customElements) customElements.define('zl-product-waitlist', ZlProductWaitlist);
})();
